import { authorizedRequest } from "../../../services/apiClient";
import { buildQueryString } from "../../../utils/queryParams";
import type { PaginationParams } from "@/types/api";

export interface BillingSummaryResponse {
  wallet_id: string;
  currency: string;
  balance_cents: number;
  balance_credits: number;
  low_balance_threshold_credits: number;
  lot_creation_cost_credits?: number;
  status: "active" | "suspended";
}

export interface BillingLedgerEntry {
  id: string;
  entry_type: string;
  amount_cents: number;
  amount_credits: number;
  currency: string;
  workspace_id?: string | null;
  provider_transaction_id?: string | null;
  request_id?: string | null;
  description_key?: string | null;
  created_at: string;
}

export interface BillingLedgerResponse {
  entries: BillingLedgerEntry[];
  total: number;
}

export interface LedgerQueryParams extends PaginationParams {
  workspaceId?: string;
}

export interface TopUpResponse {
  session_id: string;
  checkout_url: string;
  expires_at: string;
  reference: string;
  amount_cents: number;
  currency: string;
}

export async function fetchBillingSummary(
  accessToken: string
): Promise<BillingSummaryResponse> {
  return authorizedRequest<BillingSummaryResponse>(accessToken, "/credits/balance");
}

export async function fetchBillingLedger(
  accessToken: string,
  params: LedgerQueryParams
): Promise<BillingLedgerResponse> {
  const path =
    "/credits/history" +
    buildQueryString({
      workspace_id: params.workspaceId,
      limit: params.limit,
      offset: params.offset
    });
  return authorizedRequest<BillingLedgerResponse>(accessToken, path);
}

export async function createTopUpSession(
  accessToken: string,
  credits: number,
  idempotencyKey: string
): Promise<TopUpResponse> {
  return authorizedRequest<TopUpResponse>(accessToken, "/credits/purchase", {
    method: "POST",
    body: JSON.stringify({ credits, idempotency_key: idempotencyKey })
  });
}
